import service from '@/utils/request'

export function userList(param) {
	return service.request({
		method: 'post',
		url: '/app/user/userList',
		data: param
	})
}
export function addUser(param) {
	return service.request({
		method: 'post',
		url: '/app1/user/add',
		data: param
	})
}

export function editUser(param) {
	return service.request({
		method: 'post',
		url: '/app/user/edit',
		data: param
	})
}
export function delUser(param) {
	return service.request({
		method: 'post',
		url: '/app/user/del',
		data: param
	})
}
export function resetPwd(param) {
	return service.request({
		method: 'post',
		url: '/app/user/resetPwd',
		data: param
	})
}
//根据角色ID查询员工信息
export function listByRoleId(param) {
	return service.request({
		method: 'post',
		url: '/app/user/listByRoleId',
		data: param
	})
}



/**
 * 用户绑定的 角色 信息查询
 * @param {Object} param
 */
export function userRoleByUserId(param) {
	return service.request({
		method: 'post',
		url: '/app/userRole/userRoleByUserId',
		data: param
	})
}
/**
 * 用户分配角色
 * @param {Object} param
 */
export function addUserRole(param) {
	return service.request({
		method: 'post',
		url: '/app/userRole/add',
		data: param
	})
}
/**
 * 用户上传头像
 * @param {Object} param
 */
export function uploadAvatar(param) {
	return service.request({
		method: 'post',
		url: '/app/user/avatar',
		data: param
	})
}
/**
 * 个人中心用户更新基本信息
 * @param {Object} param
 */
export function updateBasicUser(param) {
	return service.request({
		method: 'post',
		url: '/app/user/editBasicUser',
		data: param
	})
}
/**
 * 个人中心用户修改密码 
 * @param {Object} param
 */
export function resetBasicPwd(param) {
	return service.request({
		method: 'post',
		url: '/app/user/resetBasicPwd',
		data: param
	})
}
